import Vue from 'vue'
import VueRouter from 'vue-router'
import Lottery from "../views/Lottery";
import SpecialLottery from "../views/SpecialLottery";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Lottery',
		component: Lottery
	},
	{
		path: '/sorteio-especial',
		name: 'SpecialLottery',
		component: SpecialLottery
	},
	{
		path: '/carregar-lista',
		name: 'LoadList',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "loadList" */ '../views/LoadList.vue')
	},
	{
		path: '/sorteados',
		name: 'WinnersList',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "winnersList" */ '../views/Winners.vue')
	},
]

const router = new VueRouter({
	routes
})

export default router
